import React from 'react'

export default(props)=>{

    return(
        <svg width="25" height="27" viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.4999 13.0436C10.1978 13.0436 8.33325 11.0979 8.33325 8.69573C8.33325 6.29355 10.1978 4.3479 12.4999 4.3479C14.802 4.3479 16.6666 6.29355 16.6666 8.69573C16.6666 11.0979 14.802 13.0436 12.4999 13.0436ZM12.4999 15.2175C15.2812 15.2175 20.8333 16.674 20.8333 19.5653V21.7392H4.16658V19.5653C4.16658 16.674 9.71867 15.2175 12.4999 15.2175Z" fill={props.color}/>
        </svg>
    )
}